import {RainbowResponseOrderVenue} from '../../server/rainbow/types';
import {AvailabilityApiResponse} from '../../server/routes/availability/types';
import {RescheduleApiPostBody} from '../../server/routes/reschedule/types';
import {getHeaderLanguageCode} from '../../shared/utils/getHeaderLanguageCode';
import {parseJson} from '@treatwell/ui';
import {httpGetJson, httpGetText, httpPostJson} from './http';
import {filterFalseyParams} from './availability';

export type RescheduleAvailabilityApiRequestQuery = {
  token?: string | null;
  startDate?: string | null;
};

export function composeFetchApiRescheduleAvailability() {
  return ({
    token,
    startDate,
    languageCode,
  }: RescheduleAvailabilityApiRequestQuery & {
    languageCode?: string | null;
  }): Promise<AvailabilityApiResponse> => {
    const params = filterFalseyParams({token, startDate});
    const headers = getHeaderLanguageCode(languageCode);
    return httpGetJson({
      path: `/datetime-ui/api/reschedule?${params}`,
      options: {
        headers,
      },
    });
  };
}

type RescheduledOrderPostRequest = {
  token?: string | null;
  body: RescheduleApiPostBody;
};

export type RescheduledOrderPostResponse = {
  startDate: string;
  startTime: string;
};

export function composePostRescheduledOrder() {
  return ({
    token,
    body,
  }: RescheduledOrderPostRequest): Promise<RescheduledOrderPostResponse> => {
    const params = filterFalseyParams({token});
    return httpPostJson({
      path: `/datetime-ui/api/reschedule?${params}`,
      body,
    });
  };
}

export function composeFetchOrderVenue() {
  return ({token}: {token: string}) => {
    return httpGetText<string>({
      path: `/api/v1/me/order/${token}`,
    }).then((response) => parseJson<RainbowResponseOrderVenue>(response));
  };
}
